import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface RawResult {
  updateAppUser: boolean;
}

export type Args = {
  appUserId: string;
  name?: string;
  start?: Date;
  end?: Date;
};

export const updateAppUser = async <V>(
  apollo: DollarApollo<V>,
  args: Args
): Promise<FetchResult<RawResult>> => {
  const { appUserId, name, start, end } = args;
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: {
      appUserId,
      name,
      start: start && start.getTime(),
      end: end && end.getTime()
    }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
